// Module
var code = "<input type=\"text\"/> <md-button class=\"md-icon-button fg-accent abx-calendar-button\" ng-click=\"vm.showCalendarPanel($event)\"> <i class=\"material-icons md-24\">today</i> </md-button> ";
// Exports
module.exports = code;